import { render, staticRenderFns } from "./preheader.vue?vue&type=template&id=fc207424&scoped=true&"
import script from "./preheader.vue?vue&type=script&lang=js&"
export * from "./preheader.vue?vue&type=script&lang=js&"
import style0 from "./preheader.vue?vue&type=style&index=0&id=fc207424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc207424",
  null
  
)

export default component.exports